* {
  box-sizing: border-box;
}

:host {
  display: block;
  height: auto;
  max-width: 100%;
  --icon-size: 16px;
}

.wrapper {
  padding: 2px;
  flex-direction: column;

  .title-container {
    display: flex;
    align-items: center;
    flex: 1;
    padding-left: var(--spacer);
    width: calc(100% - 24px);

    gz-text[class='date'] {
      text-align: right;
      padding-right: var(--spacer);
    }
    .icon {
      padding-right: calc(var(--spacer) * 2);
      color: var(--chart-302-icon-buttons-titles);

      &:after {
        content: '';
        width: 25px;
        height: 25px;
        top: 2px;
        left: 3px;
        border-radius: 50%;
        position: absolute;
        border: 1px solid currentColor;
      }

      &:before {
        font-size: var(--icon-size);
      }
    }
  }

  gz-text[class='edited-text'] {
    display: inline;
    font-size: var(--body-size-xsmall);
  }

  gz-title[id='userFullname'] {
    display: inline;
  }

  gz-tooltip {
    flex: 1;
  }

  gz-text[id='createdDate'] {
    flex: 0.6;
  }

  gz-text[id='description'],
  gz-title[id='userFullname'] {
    font-weight: 500;
  }

  gz-text[class='edited-text'],
  gz-text[id='createdDate'] {
    color: var(--chart-302-icon-buttons-titles);
  }

  gz-text[id='description'] {
    padding-top: calc(var(--spacer) * 2 - 4px);
    padding-right: var(--spacer);
    white-space: pre-line;
    word-break: break-word;
  }

  gz-select[id='noteCardMenu'] {
    &.not-visible {
      visibility: hidden;
    }
  }
}
